<template>
  <el-dialog
    center
    :close-on-click-modal="false"
    :show-close="false"
    custom-class="ads-term-and-condition-modal"
    :visible="visible"
    top="20px"
  >
    <div class="docs-icon p-4 rounded-full mx-auto mb-5">
      <svg-icon color="var(--warning-intense)" icon-class="docs-tnc" />
    </div>

    <h3 class="text-center text-black text-2xl font-semibold mb-2">
      {{ $t('ads_tnc_title') }}
    </h3>
    <p class="text-center mb-5">
      {{ $t('ads_tnc_desc') }}
    </p>

    <div class="tnc-container rounded-xl mb-3">
      <h4 class="mb-1 text-xl text-black font-semibold">
        {{ $t('ads_tnc_subtitle') }}
      </h4>
      <!-- Terms & Conditions only available in English -->
      <p dir="ltr">
        {{ TERMS_AND_CONDITIONS }}
      </p>
    </div>

    <div slot="footer" class="footer flex gap-3">
      <BaseButton
        class="flex-1"
        type="tertiary"
        :disabled="loading"
        track-id="ads_terms_cancel"
        @click="$emit('cancel')"
      >
        {{ $t('ads_tnc_cancel') }}
      </BaseButton>
      <BaseButton
        type="primary"
        class="flex-1"
        :disabled="loading"
        track-id="ads_terms_confirm"
        @click="$emit('confirm')"
      >
        {{ $t('ads_tnc_confirm') }}
      </BaseButton>
    </div>
  </el-dialog>
</template>

<script>
import BaseButton from '@/components/lavender/v2/BaseButton.vue'
import TERMS_AND_CONDITIONS from '@/views/ads/constants/terms-and-conditions'

export default {
  name: 'AdsTermAndConditionModal',
  components: { BaseButton },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      TERMS_AND_CONDITIONS,
    }
  },
}
</script>

<style lang="scss" scoped>
.docs-icon {
  width: 72px;
  height: 72px;
  background: var(--warning-subtle); // 10% opacity

  svg {
    width: 40px;
    height: 40px;
  }
}

::v-deep {
  .ads-term-and-condition-modal {
    max-width: 800px;
    border-radius: 16px;
  }
  .el-dialog__header {
    padding-block: 36px 16px;
    padding-inline: 40px;
  }

  .el-dialog__body {
    padding-block: 0;
    padding-inline: 40px;
  }

  .el-dialog__footer {
    padding-block: 16px 36px;
    padding-inline: 40px;
  }
}

p {
  color: var(--content-mid);
  white-space: pre-wrap;
}

.tnc-container {
  height: 300px;
  padding: 14px 16px;
  overflow: auto;
  background: var(--border-low);
}

.footer {
  height: 52px;
  [dir='rtl'] & {
    flex-direction: row-reverse;
  }
}

.global__button {
  &:hover {
    border: 1px solid #000;
  }
  &:hover:disabled {
    border: 1px solid transparent;
  }
}

.global__button-black {
  font-size: 16px;
}

.global__button-black,
.global__button {
  @apply rounded-full;
}
</style>
